import { useEffect } from "react";
import { useLocation } from "react-router";

/**
 * React Router doesn't scroll to `#fragment` after navigation. This effect
 * watches the location and scrolls the matching element into view when the
 * hash changes (or after a navigation that arrives with a hash).
 */
export function ScrollToHash() {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    if (!hash) {
      // Plain navigation (no fragment) — scroll to top.
      window.scrollTo({ top: 0, behavior: "instant" });
      return;
    }
    const id = hash.slice(1);
    // Try immediately, and once more after the next paint, in case the
    // target section is rendered lazily after route transition.
    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return true;
      }
      return false;
    };
    if (!tryScroll()) {
      const raf = window.requestAnimationFrame(() => {
        if (!tryScroll()) {
          // One last try after a short delay for big sections.
          window.setTimeout(tryScroll, 80);
        }
      });
      return () => window.cancelAnimationFrame(raf);
    }
    // pathname + key keep this effect re-running on Same-page hash changes.
  }, [pathname, hash, key]);

  return null;
}
